import moment from "moment";
import { ISlot, ITeeTimeSlotNew } from "redux/reducers/models/teetime";

export interface IPaceTimes {
  teeOffTime: string;
  turnTime: string;
  finishTime: string;
}

export interface IPaceSettings {
  power_cart_nine_hole_time: number;
  power_cart_eighteen_hole_time: number;
}

type PaceSlot = ITeeTimeSlotNew | ISlot;

export function normalizePaceTimes(slot: PaceSlot): IPaceTimes {
  if ("tee_time_booking_participant_tee_off_time" in slot) {
    return {
      teeOffTime: slot.tee_time_booking_participant_tee_off_time ?? "",
      turnTime: slot.tee_time_booking_participant_turn_time ?? "",
      finishTime: slot.tee_time_booking_participant_finish_time ?? "",
    };
  }

  return {
    teeOffTime: slot.booking_participant?.tee_off_time ?? "",
    turnTime: slot.booking_participant?.turn_time ?? "",
    finishTime: slot.booking_participant?.finish_time ?? "",
  };
}

export function getGroupPaceTimes(slots: PaceSlot[]): IPaceTimes {
  const teeOffSlot = slots?.find(slot => normalizePaceTimes(slot).teeOffTime);
  const turnSlot = slots?.find(slot => normalizePaceTimes(slot).turnTime);
  const finishSlot = slots?.find(slot => normalizePaceTimes(slot).finishTime);

  return {
    teeOffTime: teeOffSlot ? normalizePaceTimes(teeOffSlot).teeOffTime : "",
    turnTime: turnSlot ? normalizePaceTimes(turnSlot).turnTime : "",
    finishTime: finishSlot ? normalizePaceTimes(finishSlot).finishTime : "",
  };
}

export function determineOverPace(
  paceTimes: IPaceTimes,
  facilityHoles: number,
  settings: IPaceSettings,
): boolean {
  const expectedTurnTime = settings?.power_cart_nine_hole_time;
  const expectedFinishTime = settings?.power_cart_eighteen_hole_time;

  const turnTimeDifference = moment(paceTimes.turnTime, "YYYY-MM-DD HH:mm").diff(
    moment(paceTimes.teeOffTime, "YYYY-MM-DD HH:mm"),
    "minutes",
  );
  const finishTimeDifference = moment(paceTimes.finishTime, "YYYY-MM-DD HH:mm").diff(
    moment(paceTimes.teeOffTime, "YYYY-MM-DD HH:mm"),
    "minute",
  );

  let turnOverPace = false;
  let finishOverPace = false;

  if (
    facilityHoles === 18 &&
    turnTimeDifference &&
    turnTimeDifference > 0 &&
    (!finishTimeDifference || finishTimeDifference === 0)
  ) {
    turnOverPace = turnTimeDifference > expectedTurnTime;
  }

  if (finishTimeDifference && finishTimeDifference > 0) {
    finishOverPace = finishTimeDifference > expectedFinishTime;
  }

  return turnOverPace || finishOverPace;
}

export function isSlotOverPace(
  slot: PaceSlot,
  facilityHoles: number,
  settings: IPaceSettings,
): boolean {
  return determineOverPace(normalizePaceTimes(slot), facilityHoles, settings);
}

export function isGroupOverPace(
  slots: PaceSlot[],
  facilityHoles: number,
  settings: IPaceSettings,
): boolean {
  return slots?.some(slot => isSlotOverPace(slot, facilityHoles, settings)) ?? false;
}

export function displayTurnTime(facilityHoles: number): boolean {
  return facilityHoles === 18 || facilityHoles === 12;
}
